export type AppRole = 'super_admin' | 'sales_admin' | 'team_leader' | 'sales_rep' | 'admin';

export interface RolePermission {
  displayName: string;
  maxDiscount: number;
  canManageProducts: boolean;
  canManagePolicies: boolean;
  canImpersonate: boolean;
  canViewAllQuotes: boolean;
  canOverridePayment: boolean;
  canReassignAppointments: boolean;
  canBulkEditOwnAppointments: boolean;
  canBulkEditAllAppointments: boolean;
}

export const RolePermissions: Record<AppRole, RolePermission> = {
  super_admin: {
    displayName: 'Super Admin',
    maxDiscount: 100,
    canManageProducts: true,
    canManagePolicies: true,
    canImpersonate: true,
    canViewAllQuotes: true,
    canOverridePayment: true,
    canReassignAppointments: true,
    canBulkEditOwnAppointments: true,
    canBulkEditAllAppointments: true,
  },
  sales_admin: {
    displayName: 'Sales Admin',
    maxDiscount: 50,
    canManageProducts: true,
    canManagePolicies: true,
    canImpersonate: true,
    canViewAllQuotes: true,
    canOverridePayment: true,
    canReassignAppointments: true,
    canBulkEditOwnAppointments: true,
    canBulkEditAllAppointments: true,
  },
  team_leader: {
    displayName: 'Team Leader',
    maxDiscount: 25,
    canManageProducts: false,
    canManagePolicies: false,
    canImpersonate: false,
    canViewAllQuotes: false,
    canOverridePayment: true,
    canReassignAppointments: true,
    canBulkEditOwnAppointments: true,
    canBulkEditAllAppointments: false,
  },
  sales_rep: {
    displayName: 'Sales Rep',
    maxDiscount: 10,
    canManageProducts: false,
    canManagePolicies: false,
    canImpersonate: false,
    canViewAllQuotes: false,
    canOverridePayment: false,
    canReassignAppointments: false,
    canBulkEditOwnAppointments: true,
    canBulkEditAllAppointments: false,
  },
  admin: {
    displayName: 'Admin (Legacy)',
    maxDiscount: 100,
    canManageProducts: true,
    canManagePolicies: true,
    canImpersonate: true,
    canViewAllQuotes: true,
    canOverridePayment: true,
    canReassignAppointments: true,
    canBulkEditOwnAppointments: true,
    canBulkEditAllAppointments: true,
  },
};

export const getRolePermissions = (role: AppRole | null): RolePermission | null => {
  if (!role) return null;
  return RolePermissions[role] || null;
};
